import BaseLogCard from './BaseLogCard';
import AuditLogLogCard from './AuditLogLogCard';

export { BaseLogCard, AuditLogLogCard };
